// No Núcleo Desktop, o Electron não tem a janela "escolha a porta" do Chrome:
// quando o painel pede a porta (navigator.serial.requestPort), o app manda a
// lista para cá (preload: nucleoDesktop.balanca) e esta janela devolve a
// escolhida. No Chrome/Edge o próprio navegador mostra a lista e isto não aparece.
import { Cable } from "lucide-react";
import { useEffect, useState } from "react";

import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export default function EscolherPortaDialog() {
  const [portas, setPortas] = useState(null);
  const ponte = typeof window !== "undefined" ? window.nucleoDesktop?.balanca : null;

  useEffect(() => {
    if (!ponte?.aoListarPortas) return undefined;
    return ponte.aoListarPortas((lista) => setPortas(lista || []));
  }, [ponte]);

  if (!ponte) return null;
  const responder = (portId) => { ponte.escolherPorta(portId || ""); setPortas(null); };

  return (
    <Dialog open={portas !== null} onOpenChange={(aberto) => { if (!aberto) responder(""); }}>
      <DialogContent className="sm:max-w-md" data-e2e="balanca-portas">
        <DialogHeader>
          <DialogTitle>Porta da balança</DialogTitle>
          <DialogDescription>Escolha onde o cabo da balança está ligado.</DialogDescription>
        </DialogHeader>
        {portas && portas.length === 0 && (
          <p className="text-sm text-muted-foreground">
            Nenhuma porta encontrada. Confira se o cabo está ligado e, no caso de cabo USB, se o driver do adaptador está instalado.
          </p>
        )}
        <div className="space-y-2">
          {(portas || []).map((p) => (
            <button key={p.portId} type="button" onClick={() => responder(p.portId)}
              className="w-full flex items-center gap-3 p-3 rounded-lg border text-left hover:bg-muted/40">
              <Cable className="w-4 h-4 text-muted-foreground shrink-0" />
              <span className="min-w-0">
                <span className="block text-sm font-semibold truncate">{p.displayName || p.portName || "Porta serial"}</span>
                {p.portName && p.displayName && <span className="block text-xs text-muted-foreground">{p.portName}</span>}
              </span>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
